import { render, staticRenderFns } from "./VFormError.vue?vue&type=template&id=d43c3b48&"
import script from "./VFormError.vue?vue&type=script&lang=js&"
export * from "./VFormError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports